<div class="clients-table-container mt-24">
  <div class="clients-table-container-header-flex">
    <form [formGroup]="filterForm" class="clients-table-options">
      <div class="search-bar">
        <img
          src="../../../assets/icons/search-icon.svg"
          alt="Search Icon"
          class="search-icon"
        />
        <input
          type="text"
          class="search-bar-input custom_search_table_input"
          [placeholder]="'comercial.clients.searchPlaceholder' | translate"
          formControlName="search"
        />
      </div>

      <div>
        <ng-select
          class="zone-select"
          [placeholder]="'comercial.prices.zoneOperative' | translate"
          [items]="zones"
          bindLabel="zoneName"
          bindValue="zoneId"
          formControlName="zoneId"
          [multiple]="false"
          [clearable]="true"
          aria-label="Filtrar por zona"
        >
        </ng-select>
      </div>
    </form>

    <div class="clients-table-container-header-head">
      <div class="result-label">
        <span class="result-title" aria-hidden="true">
          {{ "comercial.clients.resultsLabel" | translate }}
        </span>

        <ng-container *ngIf="isLoading$ | async; else countTpl">
          <span
            class="inline-loader"
            title="{{ 'comercial.clients.loading' | translate }}"
          >
            <tui-loader size="s"></tui-loader>
          </span>
        </ng-container>

        <ng-template #countTpl>
          <span class="results-number"
            >({{ (totalFiltered$ | async) || 0 }})</span
          >
        </ng-template>
      </div>

      <tui-hosted-dropdown
        tuiDropdownLimitWidth="auto"
        [content]="download_options"
        [open]="isDropdownOpen"
        (openChange)="isDropdownOpen = $event"
      >
        <button
          tuiHostedDropdownHost
          class="export-button"
          [disabled]="
            (isLoading$ | async) ||
            false ||
            ((totalFiltered$ | async) || 0) === 0
          "
          [attr.aria-disabled]="
            (isLoading$ | async) ||
            false ||
            ((totalFiltered$ | async) || 0) === 0
          "
          title="{{ 'comercial.clients.exportButton' | translate }}"
        >
          <img
            src="../../../assets/icons/download-Icon.svg"
            alt=""
            class="img-icon"
          />
          {{ "comercial.clients.exportButton" | translate }}
        </button>
      </tui-hosted-dropdown>
    </div>
  </div>

  <ng-container *ngIf="isLoading$ | async; else tableAndPaginator">
    <div
      class="mt-24 loader-centered"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <tui-loader size="l"></tui-loader>
    </div>
  </ng-container>

  <ng-template #tableAndPaginator>
    <div class="table-container mt-24" *ngIf="view$ | async as view">
      <table
        tuiTable
        size="l"
        style="width: 100%"
        [columns]="columns"
        role="table"
        aria-label="Clients table"
      >
        <thead tuiThead>
          <tr tuiThGroup>
            <th
              tuiTh
              class="th-style"
              *tuiHead="'businessName'"
              (click)="onSort('businessName')"
            >
              {{ "comercial.clients.columnBusinessName" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'zoneName'"
              (click)="onSort('zoneName')"
            >
              {{ "comercial.clients.zoneName" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'userId'"
              (click)="onSort('userId')"
            >
              {{ "comercial.clients.columnUserId" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'isEnabled'"
              (click)="onSort('isEnabled')"
            >
              {{ "comercial.clients.columnStatus" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'clientPlan'"
              (click)="onSort('clientPlan')"
            >
              {{ "comercial.clients.columnClientPlan" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'email'"
              (click)="onSort('email')"
            >
              {{ "comercial.clients.columnEmail" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'contactName'"
              (click)="onSort('contactName')"
            >
              {{ "comercial.clients.contactName" | translate }}
            </th>

            <th
              tuiTh
              class="th-style"
              *tuiHead="'phoneNumber'"
              (click)="onSort('phoneNumber')"
            >
              {{ "comercial.clients.columnPhone" | translate }}
            </th>

            <th tuiTh class="th-style" *tuiHead="'actions'" [sorter]="null">
              {{ "comercial.clients.columnActions" | translate }}
            </th>
          </tr>
        </thead>

        <tbody tuiTbody>
          <tr tuiTr *ngFor="let item of view.page; trackBy: trackByUserId">
            <td tuiTd *tuiCell="'businessName'">
              <div [tuiCell]="size">
                <span tuiTitle>{{ item.businessName | emptyValue }}</span>
              </div>
            </td>

            <td tuiTd *tuiCell="'zoneName'">
              <div [tuiCell]="size">
                <span tuiTitle>{{ item.zoneName | emptyValue }}</span>
              </div>
            </td>

            <td tuiTd *tuiCell="'userId'">
              <div [tuiCell]="size">
                <span tuiTitle>{{ item.userId | emptyValue }}</span>
              </div>
            </td>

            <td tuiTd *tuiCell="'isEnabled'">
              <tui-badge
                *ngIf="item.isEnabled"
                status="success"
                [value]="'comercial.clients.statusActive' | translate"
                class="ml-5"
              ></tui-badge>
              <tui-badge
                *ngIf="!item.isEnabled"
                status="error"
                [value]="'comercial.clients.statusInactive' | translate"
                class="ml-5"
              ></tui-badge>
            </td>

            <td tuiTd *tuiCell="'clientPlan'">
              <div [tuiCell]="size">
                <span tuiTitle>{{
                  CLIENT_PLAN_I18N_KEY[item.clientPlan] | translate
                }}</span>
              </div>
            </td>

            <td tuiTd *tuiCell="'email'">
              <a
                class="mail_table_link"
                [href]="'mailto:' + (item.email | emptyValue)"
              >
                {{ item.email | emptyValue }}
              </a>
            </td>

            <td tuiTd *tuiCell="'contactName'">
              <div [tuiCell]="size">
                <span tuiTitle>{{ item.contactName | emptyValue }}</span>
              </div>
            </td>

            <td tuiTd *tuiCell="'phoneNumber'">
              {{ item.phoneNumber | emptyValue }}
            </td>

            <td tuiTd *tuiCell="'actions'" class="actions-cell">
              <div class="dropdown-container">
                <button
                  class="ellipsis-button"
                  type="button"
                  (click)="toggleMenu(item.userId)"
                  [attr.aria-expanded]="openMenuId === item.userId"
                >
                  <tui-icon icon="tuiIconMoreVertical"></tui-icon>
                </button>

                <div
                  *ngIf="openMenuId === item.userId"
                  class="dropdown-menu"
                  (click)="$event.stopPropagation()"
                >
                  <button type="button" (click)="goToDetails(item)">
                    <img [src]="plusBlack" alt="" />
                    <span>{{
                      "comercial.clients.add_discounts" | translate
                    }}</span>
                  </button>
                  <button type="button" (click)="openEditClient(item)">
                    <img [src]="pencilOutline" alt="" />
                    <span>{{ "comercial.clients.edit" | translate }}</span>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="view$ | async as view">
      <p
        class="text-center mt-4"
        *ngIf="view.total === 0 && (isLoading$ | async) === false"
      >
        {{ "comercial.clients.noData" | translate }}
      </p>
    </div>

    <div class="table-pagination mt-24">
      <tui-pagination
        *ngIf="((totalFiltered$ | async) || 0) > 0"
        [index]="(state$ | async)?.pageIndex || 0"
        [length]="(pages$ | async) || 1"
        (indexChange)="onPageChange($event)"
        aria-label="Paginación de clientes"
      ></tui-pagination>
    </div>
  </ng-template>

  <ng-template #download_options>
    <form
      [formGroup]="exportOptions"
      class="download-menu"
      aria-label="export-options"
    >
      <label class="mb-2 export-title">
        {{ "comercial.clients.exportListTitle" | translate }}
      </label>

      <div class="export-body-label">
        <tui-checkbox
          formControlName="xls"
          class="tui-space_bottom-3"
        ></tui-checkbox>
        <label>{{ "comercial.clients.exportXLS" | translate }}</label>
      </div>

      <div class="export-body-label">
        <tui-checkbox
          formControlName="csv"
          class="tui-space_bottom-3"
        ></tui-checkbox>
        <label>{{ "comercial.clients.exportCSV" | translate }}</label>
      </div>

      <div class="mt-12">
        <button
          class="export-button-menu mt-1"
          (click)="export()"
          type="button"
          [disabled]="
            !(exportOptions.value?.xls || exportOptions.value?.csv) ||
            exportLoading
          "
        >
          <div *ngIf="!exportLoading">
            <img
              src="../../../assets/icons/download-Icon.svg"
              alt=""
              class="img-icon"
            />
            <span>{{ "comercial.clients.exportAction" | translate }}</span>
          </div>

          <div *ngIf="exportLoading">
            <span aria-hidden="true">
              <tui-loader size="s"></tui-loader>
            </span>
          </div>
        </button>
      </div>
    </form>
  </ng-template>
</div>
